import axios from "axios";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";
import { RoleEditSchema } from "../../../ValidationSchema";


const RoleEdit = () => {
  const location = useLocation();
  const Navigate = useNavigate();
  const [initialValues, setInitialValues] = useState({
    name: "",
  });

  const GetUserData = () => {
    axios
      .get(
        `${process.env.REACT_APP_URL}/admin/roles/edit-get?id=${location?.state?.id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("Token")}`,
          },
        }
      )
      .then((res) => {
        if (res.status === 200) {
          setInitialValues({
            name: res?.data?.data?.name,
          });
        }
      })
      .catch((err) => {

        const MSG = ["Token not found.", "Invalid token.", "Unauthorized."];
        const STATUS = [401, 403];
        if (
          STATUS.includes(err.response.status) ||
          MSG.includes(err.response.data.msg)
        ) {
          localStorage.clear();
          Navigate("/admin/login");
        } else {
          toast.error(err?.response?.data?.msg);
        }
      });
  };

  const AddRoom = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema: RoleEditSchema,

    onSubmit: (values, action) => {
      let data = {
        id: location?.state?.id,
        name: values.name,
      };
      axios
        .post(`${process.env.REACT_APP_URL}/admin/roles/store`, data, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("Token")}`,
          },
        })
        .then((res) => {
          if (res.status === 200) {
            toast.success(`Role Updated Successfully`);
            Navigate("/admin/role", { state: res.data.msg });
          }
        })
        .catch((err) => {
          toast.error(err.response.data.msg);
        });
    },
  });

  //   const UserRole = () => {
  //     axios
  //       .get(`${process.env.REACT_APP_URL}/common/roles`)
  //       .then((res) => {
  //         setUserRole(res.data.roles);
  //       })
  //       .catch((err) => {
  //         if (err.response.data.message === "Unauthorized!") {
  //           Navigate("/admin/login");
  //         }
  //       });
  //   };

  useEffect(() => {
    GetUserData();
  }, []);

  return (
    <div className="al">
      <Toaster position="top-center" reverseOrder={false} />

      <div className="al-head">
        <div>
          <h1 className="al-title">Edit Role</h1>
          <p className="al-sub">Update this role.</p>
        </div>
        <div className="al-head__actions">
          <button type="button" className="al-btn" onClick={() => Navigate(-1)}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6" /></svg>
            Back
          </button>
        </div>
      </div>

      <form onSubmit={AddRoom.handleSubmit}>
        <div className="al-card">
          <div className="al-cardhead">
            <div className="al-cardhead__icon"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></svg></div>
            <h3 className="al-cardhead__title">Role Details</h3>
          </div>
          <div className="al-form">
            <div className="al-form__full">
              <label className="al-label">Name</label>
              <input className="al-input" type="text" placeholder="Enter Name"
                value={AddRoom.values.name} onChange={AddRoom.handleChange} onBlur={AddRoom.handleBlur} name="name" />
              {AddRoom.errors.name && AddRoom.touched.name ? (
                <div className="al-err">{AddRoom.errors.name}</div>
              ) : null}
            </div>
          </div>
          <div className="al-actionbar">
            <button type="button" className="al-btn" onClick={() => Navigate(-1)}>Cancel</button>
            <button type="submit" className="al-btn al-btn--primary">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>
              Save Changes
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default RoleEdit;
